import omit from 'lodash.omit';
import {
  CDNBaseWidgetSettings,
  CDNProductRaw,
  CDNWidgetSettings,
  CDNWidgetSettingsRaw,
  CDNProduct,
  CDNProductKeyObject,
} from '../types';
import { parseValues } from './utils';

export function widgetSettingsMapper(widgetSettingsRaw: CDNWidgetSettingsRaw): CDNWidgetSettings {
  const parsedSettings = parseValues<CDNBaseWidgetSettings>(widgetSettingsRaw);

  const auto_inject = parsedSettings.auto_inject === undefined ? true : parsedSettings.auto_inject;
  const valid_pages = parsedSettings.display_on ?? [];
  const is_subscription_first = parsedSettings.first_option === 'autodeliver';

  return {
    ...omit(parsedSettings, ['display_on', 'first_option']),
    auto_inject,
    valid_pages,
    is_subscription_first,
    autoInject: auto_inject,
    validPages: valid_pages,
    isSubscriptionFirst: is_subscription_first,
  };
}

export function productMapper(productRaw: CDNProductRaw): CDNProduct {
  const is_subscription_only = productRaw.subscription_options?.storefront_purchase_options === 'subscription_only';
  return {
    ...productRaw,
    is_subscription_only,
    isSubscriptionOnly: is_subscription_only,
  };
}

export function productArrayMapper(
  productsArray: {
    [key: string]: CDNProductRaw;
  }[]
): CDNProductKeyObject[] {
  return productsArray.map(productObjRaw => {
    const productObj: CDNProductKeyObject = {};
    Object.entries(productObjRaw).forEach(([key, value]) => {
      productObj[key] = productMapper(value);
    });
    return productObj;
  });
}
